import * as types from './actionTypes';

const initialState = {
  activeAccountId: null,
  customerAccounts: [],
  loading: false,
  error: null,
  fetched: false,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ACTIVE_CUSTOMER_ACCOUNT:
      return {
        ...state,
        activeAccountId: action.payload,
      };
    case types.FETCH_CUSTOMER_ACCOUNTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_CUSTOMER_ACCOUNTS_SUCCESS:
      return {
        ...state,
        loading: false,
        customerAccounts: action.payload,
        fetched: true,
      };
    case types.FETCH_CUSTOMER_ACCOUNTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        fetched: true,
      };
    case types.UPDATE_CUSTOMER_ACCOUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPDATE_CUSTOMER_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        customerAccounts: state.customerAccounts.map((account) =>
          account.id === action.payload.id ? action.payload : account,
        ),
      };
    case types.UPDATE_CUSTOMER_ACCOUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default accountReducer;
